<template>
<div class="flex flex-col">
    <template v-if="loaded">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="flex flex-col">
                <RecapMensuel :mois="statistiques.mois_annee_en_cours" />
                <TotalCumule :annees="statistiques.annees" :montant-vente="statistiques.montant_vente" :selected-years="selectedYears" />
                <PretsProgression :prets-progress="statistiques.prets_progress" />
            </div>
            <div class="flex flex-col">
                <AnneeAccordion
                    v-for="annee in statistiques.annees"
                    :key="annee.year"
                    :annee="annee"
                    :selected="selectedYears.includes(annee.year)"
                    @toggle-selected="toggleYear(annee.year)"
                />
            </div>
        </div>
    </template>
    <SpinnerLoader v-else class="mt-5"></SpinnerLoader>
</div>
</template>

<script>
import RecapMensuel from './../../components/bien/details/statistiques/RecapMensuel';
import TotalCumule from './../../components/bien/details/statistiques/TotalCumule';
import PretsProgression from './../../components/bien/details/statistiques/PretsProgression';
import AnneeAccordion from './../../components/bien/details/statistiques/AnneeAccordion';
import SpinnerLoader from './../../components/loader/SpinnerLoader';
import { inject } from 'vue'

export default {
    components: {
        RecapMensuel,
        TotalCumule,
        PretsProgression,
        AnneeAccordion,
        SpinnerLoader
    },

    data() {
        return {
            statistiques: null,
            loaded: false,
            selectedYears: [],
        }
    },

    created() {
        this.loadStatistiques()
    },

    methods: {
        async loadStatistiques() {
            const api = inject('api');

            this.loaded = false

            this.statistiques = await api.bien.getStatistiques(this.$route.params.bienUuid);
            this.selectedYears = this.statistiques.annees.map(annee => annee.year);

            this.loaded = true
        },

        toggleYear(year) {
            this.selectedYears = this.selectedYears.includes(year)
                ? this.selectedYears.filter(selected => selected !== year)
                : [...this.selectedYears, year];
        },
    }
};
</script>
